import { useCallback, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const hiddenRouteSegments = [
    "login",
    "sign-up",
    "initializing",
    "set-up",
    "verify",
    "verify-error",
    "forgot-password",
    "oauth",
];

const getRouteBase = (url) => {
    if (!url || url.startsWith("http")) {
        return null;
    }

    return `/${url.split("?")[0].split("/").filter(Boolean)[0] || ""}`;
};

const getCurrentRouteBase = (pathname) =>
    `/${pathname.split("/")[1] || "dashboard"}`;

const useHandlePageGoTo = () => {
    const navigate = useNavigate();
    const handlePageGoTo = useCallback(
        (route) => {
            if (route.startsWith("http")) {
                window.open(route, "_blank");
            } else {
                navigate(route);
            }
        },
        [navigate],
    );
    return handlePageGoTo;
};

const useIsHidden = () => {
    const location = useLocation();
    const currentPage = location.pathname.split("/")[1];
    return hiddenRouteSegments.includes(currentPage);
};

// TODO improvements?
const useIsLoginButtonsHidden = () => {
    const location = useLocation();
    const path1 = location.pathname.split("/")[1];
    const path2 = location.pathname.split("/")[2];
    const path1Match = path1 == "ap";
    const path2Match = ["vendor", "invoice"].includes(path2);
    return path1Match || path2Match;
};

const useCurrentRouteBase = () => {
    const location = useLocation();
    return useMemo(
        () => getCurrentRouteBase(location.pathname),
        [location.pathname],
    );
};

export {
    getCurrentRouteBase,
    getRouteBase,
    useCurrentRouteBase,
    useHandlePageGoTo,
    useIsHidden,
    useIsLoginButtonsHidden,
};
